import React from 'react'

export default function Loader() {
  return (
    <div className="digits">
      <svg
        className="digit"
        viewBox="-20 -20 140 240"
        width="50"
        height="150"
        strokeWidth="20"
        fill="none"
        style={{ '--fill': '#5288e1', '--i' : '1' }}
      >
        <circle
          r="20"
          cx="25"
          cy="150"
          strokeWidth="10"
          pathLength="1"
        ></circle>
        <path
          d="M 50.1 64.7 L 43.5 71.5 L 9.5 38.1 L 9.5 70.3 L 0 70.3 L 0 0.3 L 9.5 0.3 L 9.5 32.2 L 39.3 0 L 45.7 5.9 L 18.4 34.3 L 50.1 64.7 Z"
          strokeWidth="12"
        ></path>
      </svg>

      <svg
        className="digit"
        viewBox="-20 -20 140 240"
        width="50"
        height="150"
        strokeWidth="20"
        fill="none"
        style={{ '--fill': '#3da658', '--i' : '2' }}
      >
        <circle
          r="20"
          cx="30"
          cy="150"
          strokeWidth="10"
          pathLength="1"
        ></circle>
        <path
          d="M 33.8 70.9 L 24.3 70.9 L 24.3 44.3 L 0 4.8 L 8 0 L 29.4 35.5 L 50.4 0.4 L 57.9 4.8 L 33.8 44.3 L 33.8 70.9 Z"
          strokeWidth="12"
        ></path>
      </svg>

      <svg
        className="digit"
        viewBox="-20 -20 140 240"
        width="50"
        height="150"
        strokeWidth="20"
        fill="none"
        style={{ '--fill': '#d7483d', '--i' : '3' }}
      >
        <circle
          r="20"
          cx="30"
          cy="150"
          strokeWidth="10"
          pathLength="1"
        ></circle>
        <path
          d="M 48.901 3.6 L 46.001 11.6 Q 42.901 10.1 39.651 9.2 Q 36.858 8.427 33.215 8.318 A 40.705 40.705 0 0 0 32.001 8.3 A 21.173 21.173 0 0 0 24.096 9.755 A 19.981 19.981 0 0 0 20.551 11.6 A 21.167 21.167 0 0 0 14.185 18.181 A 26.978 26.978 0 0 0 12.601 21.1 Q 9.701 27.3 9.701 36.1 Q 9.701 44.5 12.551 50.8 A 25.677 25.677 0 0 0 16.137 56.628 A 21.423 21.423 0 0 0 20.451 60.6 A 19.703 19.703 0 0 0 31.596 64.097 A 23.894 23.894 0 0 0 32.001 64.1 A 33.715 33.715 0 0 0 35.972 63.879 Q 38.448 63.585 40.501 62.9 Q 44.101 61.7 47.501 59.8 L 50.401 67.7 A 37.561 37.561 0 0 1 45.906 69.744 A 47.894 47.894 0 0 1 41.951 71.05 A 33.592 33.592 0 0 1 36.985 72.041 Q 34.504 72.355 31.706 72.395 A 57.414 57.414 0 0 1 30.901 72.4 A 32.384 32.384 0 0 1 21.576 71.099 A 27.961 27.961 0 0 1 14.801 68.05 A 28.6 28.6 0 0 1 4.924 57.605 A 34.916 34.916 0 0 1 3.901 55.65 A 37.611 37.611 0 0 1 0.801 45.933 Q 0.026 41.667 0.001 36.814 A 62.816 62.816 0 0 1 0.001 36.5 Q 0.001 25.8 3.951 17.55 Q 7.901 9.3 15.151 4.65 A 29.371 29.371 0 0 1 27.831 0.239 A 37.292 37.292 0 0 1 32.101 0 A 45.639 45.639 0 0 1 37.159 0.268 A 35.2 35.2 0 0 1 41.201 0.95 A 38.224 38.224 0 0 1 48.675 3.495 A 35.605 35.605 0 0 1 48.901 3.6 Z"
          strokeWidth="12"
        ></path>
      </svg>

      <svg
        className="digit"
        viewBox="-20 -20 140 240"
        width="50"
        height="150"
        strokeWidth="20"
        fill="none"
        style={{ '--fill': '#efbe1b', '--i' : '4' }}
      >
        <circle
          r="20"
          cx="25"
          cy="150"
          strokeWidth="10"
          pathLength="1"
        ></circle>
        <path
          d="M 42 70 L 0 70 L 0 0 L 42 0 L 42 8.2 L 9.5 8.2 L 9.5 29.5 L 37.5 29.5 L 37.5 37.5 L 9.5 37.5 L 9.5 61.8 L 42 61.8 L 42 70 Z"
          strokeWidth="12"
        ></path>
      </svg>

      <svg
        className="digit"
        viewBox="-20 -20 140 240"
        width="50"
        height="150"
        strokeWidth="20"
        fill="none"
        style={{ '--fill': '#ff9800', '--i' : '5' }}
      >
        <circle
          r="20"
          cx="20"
          cy="150"
          strokeWidth="10"
          pathLength="1"
        ></circle>
        <path
          d="M 42 70 L 0 70 L 0 0 L 42 0 L 42 8.2 L 9.5 8.2 L 9.5 29.5 L 37.5 29.5 L 37.5 37.5 L 9.5 37.5 L 9.5 61.8 L 42 61.8 L 42 70 Z"
          strokeWidth="12"
        ></path>
      </svg>
    </div>
  )
}
